// Origem Flow: subtarefas estilo ClickUp modeladas com um link_row da
// tabela para ela mesma. O campo "Tarefa principal" (na filha) aponta para
// a mãe; o campo relacionado "Subtarefas" (na mãe) lista as filhas.
const PARENT_FIELD_NAMES = new Set([
  'tarefa principal',
  'tarefa pai',
  'subtarefa de',
  'parent',
  'parent task',
])

const CHILDREN_FIELD_NAMES = new Set(['subtarefas', 'subtasks'])

// Campo de responsável (colaboradores) — usado pelas subtarefas, que têm
// responsável próprio, independente da tarefa mãe.
const ASSIGNEE_FIELD_NAMES = new Set([
  'responsável',
  'responsavel',
  'responsáveis',
  'responsaveis',
  'assignee',
  'assignees',
  'atribuído a',
  'atribuido a',
])

function isSelfLink(field, tableId) {
  return field.type === 'link_row' && field.link_row_table_id === tableId
}

/**
 * O campo que aponta para a tarefa mãe: primeiro link_row auto-referente
 * com nome de "tarefa principal". Null quando a tabela ainda não tem.
 */
export function getParentTaskField(fields, tableId) {
  if (!Array.isArray(fields)) {
    return null
  }
  return (
    fields.find(
      (field) =>
        isSelfLink(field, tableId) &&
        PARENT_FIELD_NAMES.has((field.name || '').trim().toLowerCase())
    ) || null
  )
}

/**
 * O campo que lista as subtarefas de uma linha: o relacionado do campo de
 * tarefa principal, ou o primeiro link_row auto-referente com nome de
 * "subtarefas".
 */
export function getSubtasksField(fields, tableId, parentField = null) {
  if (!Array.isArray(fields)) {
    return null
  }
  if (parentField) {
    const related = fields.find(
      (field) =>
        isSelfLink(field, tableId) &&
        field.link_row_related_field === parentField.id
    )
    if (related) {
      return related
    }
  }
  return (
    fields.find(
      (field) =>
        isSelfLink(field, tableId) &&
        CHILDREN_FIELD_NAMES.has((field.name || '').trim().toLowerCase())
    ) || null
  )
}

/**
 * O campo de responsável da tabela: o campo de colaboradores chamado
 * "Responsável" (ou equivalente) e, na falta dele, o primeiro campo de
 * colaboradores. Null quando a tabela não tem nenhum.
 */
export function getAssigneeField(fields) {
  if (!Array.isArray(fields)) {
    return null
  }
  const collaboratorFields = fields.filter(
    (field) => field.type === 'multiple_collaborators'
  )
  return (
    collaboratorFields.find((field) =>
      ASSIGNEE_FIELD_NAMES.has((field.name || '').trim().toLowerCase())
    ) ||
    collaboratorFields[0] ||
    null
  )
}
